import styled from 'styled-components';

export const NotificationsListContainer = styled('div')`
  position: fixed;
  display: flex;
  flex-flow: column;
  align-items: center;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  min-width: 600px;
  max-width: 900px;
  /* Выше слоя модалок (MUI Dialog = 1300), чтобы уведомления были видны поверх открытых окон */
  z-index: 1400;
  /* Контейнер растянут по верху экрана, но не должен перехватывать клики (иначе перекрывает модалки).
     Кликабельны только сами уведомления (pointer-events: auto на элементе). */
  pointer-events: none;
`;
